document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('quiz-app');
  if (!root) return;

  /* =====================
     CORE STATE
  ===================== */
  const steps = root.querySelectorAll('.quiz-step');
  const progressContainer = root.querySelector('.quiz-progress');
  let currentStep = 0;

  const answers = {
    dogName: '',
    gender: '',
    weight: '',
    age: '',
    struggles: [],
    activity: '',
    bodyType: '',
    foodType: '',
    email: ''
  };

  /* =====================
     PROGRESS BAR
  ===================== */
  let progressBar = null;

  function initProgressBar() {
    if (!progressContainer) return;
    progressBar = document.createElement('div');
    progressBar.className = 'quiz-progress-bar';
    progressBar.style.width = '0%';
    progressContainer.innerHTML = '';
    progressContainer.appendChild(progressBar);
  }

  function updateProgress(index) {
    if (!progressBar) initProgressBar();
    const percent = ((index + 1) / steps.length) * 100;
    progressBar.style.width = percent + '%';
  }

  /* =====================
     STEP CONTROL
  ===================== */
  function showStep(index) {
    steps.forEach(step => step.classList.remove('active'));
    if (!steps[index]) return;
    steps[index].classList.add('active');
    updateProgress(index);
    updateNextState();
  }

  /* =====================
     INPUT CAPTURE
  ===================== */
  function captureInputs() {
    const inputs = steps[currentStep].querySelectorAll('input[name]');
    inputs.forEach(input => {
      if (input.name === 'struggles') return;
      answers[input.name] = input.value.trim();
    });
  }

  /* =====================
     VALIDATION
  ===================== */
  function isStepValid(stepIndex) {
    const step = steps[stepIndex];
    if (!step) return false;

    const textInput = step.querySelector(
      'input[type="text"], input[type="number"], input[type="email"]'
    );
    if (textInput) return textInput.value.trim() !== '';

    if (step.querySelector('input[type="radio"]')) {
      return step.querySelector('input[type="radio"]:checked') !== null;
    }

    if (step.querySelectorAll('input[type="checkbox"]').length) {
      return step.querySelectorAll('input[type="checkbox"]:checked').length > 0;
    }

    if (step.querySelector('[data-value]')) {
      return step.querySelector('.selected') !== null;
    }

    return true;
  }

  function updateNextState() {
    const step = steps[currentStep];
    if (!step) return;
    const nextBtn = step.querySelector('.next');
    if (!nextBtn) return;

    captureInputs(); // Capture before validation

    const valid = isStepValid(currentStep);
    nextBtn.disabled = !valid;
    nextBtn.classList.toggle('disabled', !valid);
  }

  /* =====================
     CLICK HANDLING
  ===================== */
  root.addEventListener('click', e => {
    // Option buttons
    if (e.target.dataset.value) {
      const step = steps[currentStep];
      step.querySelectorAll('[data-value]').forEach(btn =>
        btn.classList.remove('selected')
      );
      e.target.classList.add('selected');

      const key = step.dataset.key;
      if (key) {
        answers[key] = e.target.dataset.value;
      }

      updateNextState();
      return;
    }

    // Next button
    if (e.target.classList.contains('next')) {
      captureInputs();
      if (!isStepValid(currentStep)) return;
      currentStep++;
      showStep(currentStep);
    }
  });

  root.addEventListener('input', updateNextState);
  root.addEventListener('change', updateNextState);

  /* =====================
     DOG NAME PERSONALISATION
  ===================== */
  const dogNameInput = root.querySelector('input[name="dogName"]');
  const dogNameSpans = root.querySelectorAll('.dog-name');

  if (dogNameInput) {
    dogNameInput.addEventListener('input', () => {
      const name = dogNameInput.value.trim();
      answers.dogName = name;
      dogNameSpans.forEach(span => {
        span.textContent = name || 'your dog';
      });
      updateNextState();
    });
  }

  /* =====================
     FORM SUBMIT
  ===================== */
  const form = root.querySelector('#quiz-form');
  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();

      // Capture final inputs
      captureInputs();
      answers.struggles = [];
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb =>
        answers.struggles.push(cb.value)
      );

      redirectToResults();
    });
  }

  /* =====================
     REDIRECT TO RESULTS
  ===================== */
  function redirectToResults() {
    const { primary, secondary } = calculateRecommendations(answers.struggles);

    const params = new URLSearchParams({
  recommendations: primary.join(','),
  secondary: secondary.join(','),
  dog: answers.dogName || '',
  gender: answers.gender || '',
  age: answers.age || '',
  weight: answers.weight || '',
  concerns: answers.struggles ? answers.struggles.join(', ') : '',  // ← NEW: Quiz concerns
  activity: answers.activity || '',
  bodyType: answers.bodyType || '',
  foodType: answers.foodType || '',
  email: answers.email || ''
});

    window.location.href = `/pages/quiz-recommendations?${params.toString()}`;
  }

  /* =====================
     INIT
  ===================== */
  initProgressBar();
  showStep(currentStep);
});

/* =================================================
   NEW RECOMMENDATION ENGINE - TABLE-BASED
================================================= */

const PRODUCT_SCORES = {
  // Phytoplankton Probiotic Omega
  phytoplankton: {
    soft_stool: 3,
    itchy_skin: 3, 
    hot_spots: 3,
    allergies: 3,
    dull_coat: 2
  },
  // Prebiotic Digestive Support
  prebiotic: {
    soft_stool: 2,
    itchy_skin: 2,
    allergies: 2,
    sensitive_tummy: 3,
    gut_health: 3
  },
  // Dental Health
  dental: {
    dental_health: 5
  },
  // Gut Immunity
  gut_immunity: {
    soft_stool: 3,
    blocked_anal_glands: 3,
    gut_health: 2
  },
  // Derma Cream
  derma_cream: {
    itchy_skin: 3,
    hot_spots: 0,
    allergies: 2
  },
  // Hot Spot Gel
  hot_spot_gel: {
    hot_spots: 4
  },
  // Mega Oil
  mega_oil: {
    dull_coat: 3,
    itchy_skin: 2,
    allergies: 2  
  },
    derma_shampoo: {
    itchy_skin: 4,
    allergies: 3,
    dull_coat: 2,
    hot_spots: 2
  },
  derma_conditioner: {
    itchy_skin: 3,
    allergies: 3,
    dull_coat: 3
  },
  derma_cologne: {
    itchy_skin: 2,
    allergies: 2,
    hot_spots: 1
  }  

};

const PAIRINGS = {
  phytoplankton: ['prebiotic', 'derma_conditioner', 'derma_shampoo'],
  prebiotic: ['phytoplankton', 'derma_shampoo', 'derma_conditioner'],
  dental: ['prebiotic', 'gut_immunity', 'phytoplankton'],
  gut_immunity: ['mega_oil', 'derma_conditioner', 'derma_shampoo'],
  mega_oil: ['gut_immunity', 'derma_shampoo', 'derma_conditioner'],
  derma_cream: ['derma_shampoo', 'phytoplankton', 'derma_conditioner'],
  hot_spot_gel: ['derma_shampoo', 'derma_conditioner', 'prebiotic'],
  derma_shampoo: ['derma_conditioner', 'derma_cologne', 'derma_cream'],
  derma_conditioner: ['derma_shampoo', 'derma_cologne', 'derma_cream'],
  derma_cologne: ['derma_shampoo', 'derma_conditioner', 'derma_cream']
};

function calculateRecommendations(struggles = []) {
  const scores = {};
  
  // Score all products from table
  Object.keys(PRODUCT_SCORES).forEach(product => {
    scores[product] = 0;
    Object.keys(PRODUCT_SCORES[product]).forEach(issue => {
      if (struggles.includes(issue)) {
        scores[product] += PRODUCT_SCORES[product][issue];
      }
    });
  });

  // Rank by score
  const ranked = Object.entries(scores)
    .filter(([_, score]) => score > 0)
    .sort((a, b) => b[1] - a[1])
    .map(([product]) => product);

  let primary = ranked.slice(0, 3);  // Top 3 products
  
  let secondary = [];
  primary.forEach(product => {
    (PAIRINGS[product] || []).forEach(pair => {
      if (!primary.includes(pair) && !secondary.includes(pair) && secondary.length < 3) {
        secondary.push(pair);
      }
    });
  });

  return { primary, secondary: secondary.slice(0, 3) };
}


